import { apiSlice } from "../../app/api/apiSlice";

export const supportTicketApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSupportTickets: builder.query({
      query: (params) => ({
        url: "/api/v1/resources/support_tickets/",
        method: "GET",
        params,
      }),
      providesTags: (result) =>
        result?.results
          ? [
              ...result.results.map(({ id }) => ({ type: "SupportTicket", id })),
              { type: "SupportTicket", id: "LIST" },
            ]
          : [{ type: "SupportTicket", id: "LIST" }],
    }),

    getSupportTicketById: builder.query({
      query: (id) => ({
        url: `/api/v1/resources/support_tickets/${id}/`,
        method: "GET",
      }),
      providesTags: (result, error, id) => [{ type: "SupportTicket", id }],
    }),

    createSupportTicket: builder.mutation({
      query: (body) => ({
        url: "/api/v1/resources/support_tickets/",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "SupportTicket", id: "LIST" }],
    }),

    createSupportReply: builder.mutation({
      query: ({ ticketId, body, image_s3_key }) => ({
        url: `/api/v1/resources/support_tickets/${ticketId}/replies/`,
        method: "POST",
        body: { body, ...(image_s3_key ? { image_s3_key } : {}) },
      }),
      invalidatesTags: (result, error, { ticketId }) => [
        { type: "SupportTicket", id: ticketId },
        { type: "SupportTicket", id: "LIST" },
      ],
    }),

    closeSupportTicket: builder.mutation({
      query: (ticketId) => ({
        url: `/api/v1/resources/support_tickets/${ticketId}/`,
        method: "PATCH",
        body: { status: "closed" },
      }),
      invalidatesTags: (result, error, ticketId) => [
        { type: "SupportTicket", id: ticketId },
        { type: "SupportTicket", id: "LIST" },
      ],
    }),

    getSupportTicketImageUrl: builder.query({
      query: (ticketId) => ({
        url: `/api/v1/resources/support_tickets/${ticketId}/image_url/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetSupportTicketsQuery,
  useGetSupportTicketByIdQuery,
  useCreateSupportTicketMutation,
  useCreateSupportReplyMutation,
  useCloseSupportTicketMutation,
  useGetSupportTicketImageUrlQuery,
} = supportTicketApiSlice;
